import axios from "axios";
import AXIOS from "../../utils/AXIOS";

export const NotificationDataGetAction = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const auth_id = state.contactData.auth_id; 
    const response = await axios.post(
      AXIOS.defaultPort + AXIOS.notificationGet,
      {
        auth_id,
      }
    );

    dispatch({
      type: "NOTIFICATION_DATA_GET",
      payload: response.data,
    });
  } catch (error) {
    console.error("Error fetching notification data:", error);
  }
};
